<template>
	<v-content>
		<v-container fluid pa-0 class="dashboard-layout">
			<app-header
				:title="$route.meta.title"
				:logo-url="logoUrl"
				:is-visible="false"
			/>
			<section class="dashboard-content">
				<slot></slot>
			</section>
		</v-container>
	</v-content>
</template>

<script>
import appHeader from '@/components/shared/app-header';

function getRoutes(routes) {
	this.routes = routes;
	const module = this.routes.find(mod => mod.name === this.$route.meta.title) || {};
	this.logoUrl = module.pathIcon;
}

function data() {
	return {
		logoUrl: '',
		routes: [],
	};
}

export default {
	name: 'layout-dashboard',
	components: {
		appHeader,
	},
	data,
	methods: {
		getRoutes,
	},
	watch: {
		$route(to) {
			const module = this.routes.find(mod => mod.name === to.meta.title) || {};
			this.logoUrl = module.pathIcon || to.meta.logo;
		},
	},
};
</script>

<style lang="scss" scoped>
.dashboard-layout {
	:deep(.v-content) {
		background: #f8fafc;
		padding: 0;
	}

	:deep(.container) {
		padding: 0 !important;
		max-width: 100%;
	}
}

.dashboard-content {
	min-height: calc(100vh - 64px);
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout-dashboard.vue